const breakpoints = {
  base: "0em",
  xsm: "23em", // 368px
  sm: "30em", // 480px
  md: "48em", // 768px
  mxd: "48.01em", // 769px
  lg: "62em", // 992px
  lg2: "64em", // 1024px
  lg3: "75em", // 1200px
  xl: "80em", // 1280px
  xxll: "87.5em", // 1400px
  xxl: "96em", // 1536px
  xxxl: "120em", // 1920px
}

export default breakpoints
